// axiosConfig.js — VERSION PROD-SAFE (Webpack/CRA)
import axios from "axios";

// ✅ Utilisation de process.env pour Webpack
// Note : Les variables d'environnement dans CRA doivent commencer par REACT_APP_
const API_URL = process.env.REACT_APP_API_URL || "https://souqi-api.onrender.com/api";

const api = axios.create({
  baseURL: API_URL,
});

function getMerchantToken() {
  return localStorage.getItem("merchant_token") || "";
}

function getAdminToken() {
  return localStorage.getItem("adminToken") || "";
}

api.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};
    const url = String(config.url || "");

    const isAdminRoute = url.startsWith("/admin");
    const isAdminLogin = url === "/admin/login";

    if (isAdminRoute && !isAdminLogin) {
      const adminToken = getAdminToken();
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      }
    } else {
      const merchantToken = getMerchantToken();
      if (merchantToken) {
        config.headers.Authorization = `Bearer ${merchantToken}`;
      }
    }

    const isFormData = typeof FormData !== "undefined" && config.data instanceof FormData;

    if (isFormData) {
      delete config.headers["Content-Type"];
    } else {
      const method = String(config.method || "get").toLowerCase();
      const hasBody = config.data !== undefined && config.data !== null;
      if (hasBody && (method === "post" || method === "put" || method === "patch")) {
        config.headers["Content-Type"] = "application/json";
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
// Force rebuild v2.
